import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReservationsService } from '../../services/reservations.service';
import { Waiter } from '../../models/Reservation';

@Component({
  selector: 'app-servers',
  templateUrl: './servers.component.html'
})
export class ServersComponent implements OnInit {
  @Input() restaurantId!: any;
  @Input() floorId!: any;
  @Input() reservationDate!: any;
  @Output() close = new EventEmitter<boolean>();
  @Input() open!: boolean;

  dataLoading = false;

  servers: Waiter[] = []

  constructor(private service: ReservationsService) { }

  ngOnInit(): void {
    this.waitersReservationList()
  }

  waitersReservationList() {
    this.dataLoading = true;
    this.service.ResWaitersReservationList(this.restaurantId, this.reservationDate).subscribe((data: any) => {
      this.servers = data;
      this.dataLoading = false;
    })
  }
}
